// src/pages/PrivacyPolicy.js
import React, { useEffect } from 'react';
import './LegalPage.css';

const PrivacyPolicy = () => {

  useEffect(() => {
  window.scrollTo(0, 0);
  }, []);


  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Privacy Policy</h1>
        {/* <p>Last updated: [Date]</p> */}
        
        <section>
          <h2>1. Introduction</h2>
          <p>
            AmenityScores ("us", "we", or "our") operates the AmenityScores website (the "Service").
            This page informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service.
          </p>
        </section>
        
        <section>
          <h2>2. Information Collection and Use</h2>
          <p>
            We collect several different types of information for various purposes to provide and improve our Service to you.
          </p>
          <h3>Types of Data Collected:</h3>
          <ul>
            <li><strong>Personal Data:</strong> Email address, cookies and usage data</li>
            <li><strong>Usage Data:</strong> Information about how you use our Service</li>
            <li><strong>Location Data:</strong> When you search for properties or neighborhoods</li>
          </ul>
        </section>
        
        <section>
          <h2>3. Use of Data</h2>
          <p>AmenityScores uses the collected data for various purposes:</p>
          <ul>
            <li>To provide and maintain our Service</li>
            <li>To notify you about changes to our Service</li>
            <li>To provide customer support</li>
            <li>To gather analysis to improve our Service</li>
            <li>To monitor the usage of our Service</li>
            <li>To detect, prevent and address technical issues</li>
          </ul>
        </section>
        
        <section>
          <h2>4. Data Security</h2>
          <p>
            The security of your data is important to us. We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction.
          </p>
        </section>
        
        <section>
          <h2>5. Changes to This Privacy Policy</h2>
          <p>
            We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
          </p>
        </section>
        
        <section>
          <h2>6. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us at:
            <a href="mailto: harry@amenityscores.com">harry@amenityscores.com</a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;